import { Flex, Text } from "@chakra-ui/react";

const Results = ({ actual, total }) => {
  return (
    <Flex height={["32px", "32px", "24px"]} align="center">
      {!!actual && !!total && total > 0 ? (
        <Text fontSize="sm">
          Visualizando <b>{actual < 10 ? `0${actual}` : actual}</b> resultados de{" "}
          <b>{total < 10 ? `0${total}` : total}</b>
        </Text>
      ) : (
        <Text fontSize="sm">Nenhum registro encontrado</Text>
      )}
    </Flex>
  );
};
export default Results;